import { FaCalendar, FaShieldAlt, FaEnvelope, FaPhone } from 'react-icons/fa'
import styles from './Privacy.module.css'

const Privacy = () => {
  const sections = [
    {
      title: 'Wie is verantwoordelijk?',
      content: (
        <>
          <p><strong>Sobé Zorg Twente</strong></p>
          <p>Herinckhavestraat 1<br />7557 JJ Hengelo</p>
          <p>KvK-nummer: 60235713<br />E-mail: info@sobe-zorg.nl</p>
          <p>Wij zijn de verwerkingsverantwoordelijke voor de verwerking van uw persoonsgegevens zoals beschreven in deze privacyverklaring.</p>
        </>
      )
    },
    {
      title: 'Welke gegevens verzamelen wij?',
      content: (
        <>
          <p>Wij kunnen de volgende persoonsgegevens van u verwerken:</p>
          <ul>
            <li>Naam en contactgegevens (adres, telefoonnummer, e-mailadres)</li>
            <li>Geboortedatum en BSN-nummer</li>
            <li>Zorgplannen en persoonlijke voorkeuren</li>
            <li>Financiële gegevens (voor declaraties en eigen bijdrage)</li>
            <li>Contactgegevens van familie of vertegenwoordigers</li>
            <li>Foto's en beeldmateriaal (met toestemming)</li>
            <li>Correspondentie en communicatie met u</li>
          </ul>
        </>
      )
    },
    {
      title: 'Waarom verwerken wij uw gegevens?',
      content: (
        <>
          <p>Wij verwerken uw persoonsgegevens voor de volgende doeleinden:</p>
          <ul>
            <li>Het verlenen van zorg en ondersteuning</li>
            <li>Administratieve verwerking en declaratie bij verzekeraars of gemeenten</li>
            <li>Communicatie over onze dienstverlening</li>
            <li>Voldoen aan wettelijke verplichtingen</li>
            <li>Kwaliteitsverbetering van onze zorg</li>
            <li>Beantwoorden van vragen via ons contactformulier</li>
          </ul>
        </>
      )
    },
    {
      title: 'Hoe lang bewaren wij uw gegevens?',
      content: (
        <>
          <p>Wij bewaren uw persoonsgegevens niet langer dan noodzakelijk voor de doeleinden waarvoor zij zijn verzameld.</p>
          <p>Zorgplannen en persoonlijke gegevens van cliënten bewaren wij 7 jaar na afloop van de zorgverlening. Administratieve en financiële gegevens bewaren wij eveneens 7 jaar conform de belastingwet.</p>
        </>
      )
    },
    {
      title: 'Delen wij uw gegevens?',
      content: (
        <>
          <p>Wij verstrekken uw persoonsgegevens alleen aan derden indien dit noodzakelijk is voor het uitvoeren van onze overeenkomst met u, of om te voldoen aan een wettelijke verplichting.</p>
          <p>Wij kunnen uw gegevens delen met:</p>
          <ul>
            <li>Zorgverzekeraars en gemeenten (voor declaraties)</li>
            <li>Andere zorgverleners (met uw toestemming)</li>
            <li>Het CIZ of andere indicatieorganen</li>
            <li>Leveranciers die ons ondersteunen (onder verwerkersovereenkomst)</li>
          </ul>
        </>
      )
    },
    {
      title: 'Uw rechten',
      content: (
        <>
          <p>U heeft de volgende rechten met betrekking tot uw persoonsgegevens:</p>
          <ul>
            <li><strong>Recht op inzage:</strong> U kunt opvragen welke gegevens wij van u hebben</li>
            <li><strong>Recht op correctie:</strong> U kunt onjuiste gegevens laten aanpassen</li>
            <li><strong>Recht op verwijdering:</strong> U kunt verzoeken uw gegevens te verwijderen</li>
            <li><strong>Recht op beperking:</strong> U kunt vragen de verwerking te beperken</li>
            <li><strong>Recht op overdraagbaarheid:</strong> U kunt uw gegevens in een digitaal formaat opvragen</li>
            <li><strong>Recht van bezwaar:</strong> U kunt bezwaar maken tegen de verwerking</li>
          </ul>
          <p>Om gebruik te maken van deze rechten, kunt u contact met ons opnemen via info@sobe-zorg.nl.</p>
        </>
      )
    },
    {
      title: 'Beveiliging',
      content: (
        <>
          <p>Wij nemen passende technische en organisatorische maatregelen om uw persoonsgegevens te beschermen tegen verlies of onrechtmatige verwerking. Dit omvat onder andere:</p>
          <ul>
            <li>Versleuteling van gevoelige gegevens</li>
            <li>Toegangsbeperking tot persoonsgegevens</li>
            <li>Regelmatige back-ups</li>
            <li>Training van medewerkers over gegevensbescherming</li>
          </ul>
        </>
      )
    },
    {
      title: 'Cookies',
      content: (
        <>
          <p>Onze website maakt gebruik van functionele cookies die noodzakelijk zijn voor het functioneren van de website. Wij gebruiken geen tracking cookies of cookies voor marketingdoeleinden.</p>
        </>
      )
    },
    {
      title: 'Wijzigingen',
      content: (
        <>
          <p>Wij behouden ons het recht voor om wijzigingen aan te brengen in deze privacyverklaring. Wij raden u aan om deze privacyverklaring regelmatig te raadplegen, zodat u op de hoogte blijft van eventuele wijzigingen.</p>
        </>
      )
    },
    {
      title: 'Klachten',
      content: (
        <>
          <p>Mocht u een klacht hebben over de verwerking van uw persoonsgegevens, dan verzoeken wij u hierover direct contact met ons op te nemen. U heeft ook het recht om een klacht in te dienen bij de Autoriteit Persoonsgegevens of via het Klachtenportaal.</p>
          
          <p><strong>Autoriteit Persoonsgegevens</strong><br />Postbus 93374<br />2509 AJ Den Haag<br />Telefoon: 0900 - 200 12 01<br />Website: <a href="https://autoriteitpersoonsgegevens.nl" target="_blank" rel="noopener noreferrer">autoriteitpersoonsgegevens.nl</a></p>
          
          <p><strong>Klachtenportaal Zorg</strong><br />Website: <a href="https://www.klachtenportaal.nl" target="_blank" rel="noopener noreferrer">klachtenportaal.nl</a></p>
        </>
      )
    }
  ]

  return (
    <div className={styles.privacyPage}>
      <section className={styles.pageHeader}>
        <div className="container">
          <h1 className="fade-in">Privacyverklaring</h1>
          <p className="fade-in-delay">Hoe wij omgaan met uw persoonlijke gegevens</p>
        </div>
      </section>

      <section className={styles.contentSection}>
        <div className="container">
          <div className={styles.privacyContent}>
            <div className={styles.intro}>
              <p>
                <strong>Sobé Zorg Twente</strong> vindt de bescherming van uw 
                privacy belangrijk. In deze privacyverklaring leggen wij uit welke persoonsgegevens 
                wij verzamelen, waarom wij dat doen en wat uw rechten zijn.
              </p>
              <p className={styles.lastUpdated}>
                <FaCalendar aria-hidden="true" /> Laatst bijgewerkt: 12 november 2025
              </p>
            </div>

            {sections.map((section, index) => (
              <div key={index} className={styles.privacySection}>
                <h2>
                  <span className={styles.sectionNumber}>{index + 1}</span>
                  {section.title}
                </h2>
                <div className={styles.sectionContent}>
                  {section.content}
                </div>
              </div>
            ))}

            <div className={styles.contactBox}>
              <div className={styles.contactBoxIcon}>
                <FaShieldAlt aria-hidden="true" />
              </div>
              <h3>Vragen over privacy?</h3>
              <p>Heeft u vragen over deze privacyverklaring of de verwerking van uw gegevens? Neem dan contact met ons op via <a href="mailto:info@sobe-zorg.nl">info@sobe-zorg.nl</a></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Privacy
